<template>
  <PageLayout
    title="Shrnutí"
    :prev="prevRoute"
    :next="nextRoute"
    :publish="true"
    :publish-disabled="isPublished"
    @publish="onPublishClick"
  >
    <v-row>
      <v-col cols="12" md="8" class="d-flex flex-column">
        <ReachDialBox :store-namespace="storeNamespace" class="mb-6" />
        <ui-box class="py-8 mb-6">
          <div class="body-2 font-weight-bold">
            Rozpočet: {{ budgetValue }} Kč {{ budgetTypeText }}
          </div>
          <div class="d-flex align-center">
            <span v-if="startTime"> od {{ dateFrom }} {{ timeFrom }} </span>
            <span v-if="endTimeEnabled">
              <v-icon color="primary" class="mx-1">mdi-arrow-right</v-icon>
              do {{ dateTo }} {{ timeTo }}
            </span>
          </div>
        </ui-box>
        <v-sheet
          rounded
          class="pa-16 d-flex flex-column justify-center fill-height"
        >
          <p>
            Publikováním souhlasíte s
            <a href="" class="link link-underline"
              >podmínkami společnosti Facebook Inc.</a
            >. V případě porušení těchto podmínek můžete být upozorněni na
            nedostatky reklamy, které pro své publikování budou muset být
            dodatečně odstraněny.
          </p>
          <p>
            My, Adveroo, nemůžeme ovlivnit schválení reklamy. Schvalovací proces
            je pouze v režii společnosti Facebook. Pro rychlé odbavení jakékoli
            pozdější reklamace řešte výhradně se společností Facebook
          </p>
        </v-sheet>
      </v-col>
      <v-col cols="12" md="4">
        <AdPreview :store-namespace="storeNamespace" />
      </v-col>
      <v-col cols="12">
        <Accordion
          :items="[
            {
              value: 'rules',
              title:
                'Jak dodržet pravidla Facebooku a vyhnout se zablokování reklamy nebo reklamního účtu',
            },
          ]"
        >
          <template #item.rules.content>
            <AdPolicies />
          </template>
        </Accordion>
      </v-col>
    </v-row>

    <template #navigation-right-prepend>
      <v-btn
        color="white"
        class="c-btn mx-2"
        min-width="186"
        :disabled="!_changed"
        @click="saveAdDraft"
      >
        <v-icon left>mdi-content-save-outline</v-icon>
        Uložit jako rozepsané
      </v-btn>
      <v-btn
        @click="onPublishClick"
        :disabled="isPublished"
        color="primary"
        class="c-btn mx-2"
        min-width="186"
        :loading="loading"
      >
        Publikovat
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </template>
  </PageLayout>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import PageLayout from "@/components/page/ads/edit/PageLayout.vue"
import ReachDialBox from "@/components/ui/targeting/ReachDialBox.vue"
import Accordion from "@/components/ui/widgets/Accordion.vue"
import AdPolicies from "@/components/page/ads/AdPolicies.vue"
import AdPreview from "@/components/page/ads/AdPreview.vue"
import Toastification from "../../../components/ui/Toastification"

export default {
  name: "AdSummary",
  components: {
    PageLayout,
    Accordion,
    AdPolicies,
    AdPreview,
    ReachDialBox,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    nextRoute: {
      type: String,
      default: null,
    },
    prevRoute: {
      type: String,
      default: null,
    },
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  computed: {
    budgetValue() {
      return this.budgetType === "daily"
        ? Math.floor(this.dailyBudget / 100)
        : Math.floor(this.lifetimeBudget / 100)
    },
    budgetTypeText() {
      return this.budgetType === "daily" ? "za den" : "celkem"
    },
    dateFrom() {
      return this.startTime.split("T")[0]
    },
    timeFrom() {
      return this.startTime.split("T")[1]
    },
    dateTo() {
      return this.endTime.split("T")[0]
    },
    timeTo() {
      return this.endTime.split("T")[1]
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    onPublishClick() {
      this.loading = true
      this.publishAdDraft()
        .then(() => {
          this.$router.push("/ads?success")
        })
        .catch(error => {
          this.loading = false
          this.$toast.error({
            component: Toastification,
            props: {
              title: "Reklamu nelze publikovat",
              text: error.data.exception.message,
            },
          })
        })
    },
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    if (!this.$options.methods) {
      this.$options.methods = {}
    }

    Object.assign(this.$options.computed, {
      ...get(`${storeNamespace}/model@`, ["_changed", "isPublished"]),
    })

    Object.assign(this.$options.computed, {
      ...sync(`${storeNamespace}/model@adset`, [
        "dailyBudget",
        "lifetimeBudget",
        "budgetType",
        "endTime",
        "endTimeEnabled",
        "startTime",
      ]),
    })

    Object.assign(this.$options.methods, {
      ...call(storeNamespace, ["publishAdDraft", "saveAdDraft"]),
    })
  },
}
</script>
